var __rspack_ns_object = JSON.parse('{"VENUE_PAST_HOLDS":{"TITLE":"Holds for past shows"},"VENUE_UPCOMING_HOLDS":{"TITLE":"Holds for upcoming shows"}}')